import { render, staticRenderFns } from "./MyCommunities.vue?vue&type=template&id=eba222e8&scoped=true&"
import script from "./MyCommunities.vue?vue&type=script&lang=js&"
export * from "./MyCommunities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba222e8",
  null
  
)

export default component.exports